import { call, put } from 'redux-saga/effects';
import AttemptGoalActions from '../redux/AttemptGoalRedux';
import { api } from './api';


export function* attemptGoal(action: any): Generator<any, void, any> {
  const { id } = action;
  const response = yield call(api.attemptGoal, id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(AttemptGoalActions.attemptGoalSuccess(response.data));
  } else {
    yield put(AttemptGoalActions.attemptGoalFailure());
  }
}